import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";
import { getErrorOnField, submitForm, fieldGenerator } from "utilities/form";
import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "../constants";

const FormItem = Form.Item;

const FORM_FIELDS = new OrderedMap({
    num_months: {
        type: INPUT_TYPES.RADIO,
        label: "Number of Months",
        options: [
            {
                value: 3,
                label: "3 months"
            },
            {
                value: 6,
                label: "6 months"
            }
        ]
    },
    month_year: {
        type: INPUT_TYPES.DATE_MONTH,
        label: "Month-Year",
        mode: "month"
    }
});

class StatementGeneratorForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    submitForm = submitForm.bind(this.props.form, values => {
        this.props.onFormSubmit(values);
    });

    render() {
        return (
            <Form layout={"inline"} onSubmit={this.submitForm}>
                {FORM_FIELDS.map((field, fieldName) =>
                    this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )()
                ).toList()}
                <FormItem>
                    <Button type={"primary"} htmlType="submit">
                        Create
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

StatementGeneratorForm.propTypes = {
    onFormSubmit: PropTypes.func,
    form: PropTypes.object
};

export default Form.create({})(StatementGeneratorForm);
